import { gql } from '@apollo/client'

export const EditChat = gql`
    mutation EditChat($roomId: ID!, $chatId: ID!, $text: String!) {
        editChat(roomId: $roomId, chatId: $chatId, text: $text) {
            actor {
                id
                username
            }
            id
            text
            updated
        }
    }
`

export default EditChat

